import(/* webpackMode: "eager" */ "/home/vsts/work/1/s/node_modules/@preventx/oxygen/src/components/Container/Box.tsx");
;
import(/* webpackMode: "eager" */ "/home/vsts/work/1/s/node_modules/@preventx/oxygen/src/components/Display/Card.tsx");
;
import(/* webpackMode: "eager" */ "/home/vsts/work/1/s/node_modules/@preventx/oxygen/src/components/Display/Tooltip.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Breadcrumbs"] */ "/home/vsts/work/1/s/node_modules/@preventx/oxygen/src/components/Navigation/Breadcrumbs.tsx");
;
import(/* webpackMode: "eager" */ "/home/vsts/work/1/s/node_modules/@prismicio/next/dist/PrismicNextImage.cjs");
;
import(/* webpackMode: "eager" */ "/home/vsts/work/1/s/node_modules/@prismicio/next/dist/PrismicPreviewClient.cjs");
;
import(/* webpackMode: "eager", webpackExports: ["PrismicToolbar"] */ "/home/vsts/work/1/s/node_modules/@prismicio/react/dist/PrismicToolbar.js");
;
import(/* webpackMode: "eager" */ "/home/vsts/work/1/s/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/vsts/work/1/s/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/home/vsts/work/1/s/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/home/vsts/work/1/s/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager" */ "/home/vsts/work/1/s/public/assets/branding/care-quality-commission.svg");
;
import(/* webpackMode: "eager" */ "/home/vsts/work/1/s/public/assets/branding/cwft.svg");
;
import(/* webpackMode: "eager" */ "/home/vsts/work/1/s/public/assets/branding/lloydsonlinedoctor.svg");
;
import(/* webpackMode: "eager" */ "/home/vsts/work/1/s/public/assets/branding/nhs/primary.svg");
;
import(/* webpackMode: "eager" */ "/home/vsts/work/1/s/public/assets/branding/preventx/ukas-medical-preventx.svg");
;
import(/* webpackMode: "eager" */ "/home/vsts/work/1/s/public/assets/icons/chlamydia.svg");
;
import(/* webpackMode: "eager" */ "/home/vsts/work/1/s/public/assets/icons/gonorrhoea.svg");
;
import(/* webpackMode: "eager" */ "/home/vsts/work/1/s/public/assets/icons/hepatitis.svg");
;
import(/* webpackMode: "eager" */ "/home/vsts/work/1/s/public/assets/icons/hiv.svg");
;
import(/* webpackMode: "eager" */ "/home/vsts/work/1/s/public/assets/icons/syphilis.svg");
;
import(/* webpackMode: "eager" */ "/home/vsts/work/1/s/public/assets/icons/trichomonas.svg");
;
import(/* webpackMode: "eager", webpackExports: ["LastReviewedHeadline"] */ "/home/vsts/work/1/s/src/components/Display/LastReviewedHeadline.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VimeoContainer"] */ "/home/vsts/work/1/s/src/components/Display/VimeoContainer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ContentNavigationDetails"] */ "/home/vsts/work/1/s/src/components/Navigation/ContentNavigationDetails.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ContentNavigationStandard"] */ "/home/vsts/work/1/s/src/components/Navigation/ContentNavigationStandard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ReusableContentProvider"] */ "/home/vsts/work/1/s/src/context/ReusableContentProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WithQuote"] */ "/home/vsts/work/1/s/src/slices/shared/Region/WithQuote.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WithSimpleContactDetails"] */ "/home/vsts/work/1/s/src/slices/shared/Region/WithSimpleContactDetails.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WithVimeo"] */ "/home/vsts/work/1/s/src/slices/shared/Region/WithVimeo.tsx");
